// extracted by mini-css-extract-plugin
export default {"title":"styles_title__dViXZ","button-wrapper":"styles_button-wrapper__ZFpTR"};